const TEMP_BOOKING_ID_KEY = "tempBookingID";
const SESSION_ID_KEY = "session_id";

function navigationType() {
	return performance.getEntriesByType("navigation")[0]?.type;
}

function isDuplicatedTab(navType) {
	const clonedSessionId = sessionStorage.getItem(SESSION_ID_KEY);
	// Chrome copies sessionStorage into a duplicated tab. That load is often
	// "back_forward", not "navigate". A refresh stays "reload" and keeps this
	// tab's own session. A brand-new tab has no session id yet.
	const isReload = !navType || navType === "reload";
	return !isReload && !!clonedSessionId;
}

export function shouldPreserveHold(bookingId) {
	if (bookingId == null || typeof window === "undefined" || window.__nloPreserveHoldId == null) {
		return false;
	}
	return String(bookingId) === String(window.__nloPreserveHoldId);
}

function adoptLegacyHoldIdOnReload(navType) {
	if (navType !== "reload") return;
	const legacyId = localStorage.getItem(TEMP_BOOKING_ID_KEY);
	if (legacyId && legacyId !== "null" && !sessionStorage.getItem(TEMP_BOOKING_ID_KEY)) {
		sessionStorage.setItem(TEMP_BOOKING_ID_KEY, legacyId);
	}
	if (legacyId) localStorage.removeItem(TEMP_BOOKING_ID_KEY);
}

export function initTabHoldSession() {
	if (typeof window === "undefined" || window.__nloTabHoldSessionReady) return;
	window.__nloTabHoldSessionReady = true;

	try {
		const navType = navigationType();
		if (isDuplicatedTab(navType)) {
			const clonedHoldId = sessionStorage.getItem(TEMP_BOOKING_ID_KEY);
			window.__nloPreserveHoldId = clonedHoldId && clonedHoldId !== "null" ? clonedHoldId : null;
			sessionStorage.removeItem(SESSION_ID_KEY);
			sessionStorage.removeItem(TEMP_BOOKING_ID_KEY);
		} else {
			adoptLegacyHoldIdOnReload(navType);
		}

		if (!sessionStorage.getItem(SESSION_ID_KEY)) {
			sessionStorage.setItem(SESSION_ID_KEY, crypto.randomUUID());
		}
	} catch {
		// sessionStorage can throw in private mode; the session effect retries the id.
	}
}

export function readTempBookingId() {
	if (typeof window === "undefined") return null;
	try {
		const id = sessionStorage.getItem(TEMP_BOOKING_ID_KEY);
		return id && id !== "null" ? Number(id) : null;
	} catch {
		return null;
	}
}

export function saveTempBookingId(id) {
	if (typeof window === "undefined") return;
	try {
		if (id == null || id === "" || id === "null") {
			sessionStorage.removeItem(TEMP_BOOKING_ID_KEY);
			return;
		}
		sessionStorage.setItem(TEMP_BOOKING_ID_KEY, String(id));
	} catch {
		// Ignore quota / private-mode failures. React state still holds the id.
	}
}

export function clearTempBookingId() {
	if (typeof window === "undefined") return;
	try {
		sessionStorage.removeItem(TEMP_BOOKING_ID_KEY);
	} catch {
		// Ignore private-mode failures.
	}
}
